import { render, staticRenderFns } from "./validation-errors.vue?vue&type=template&id=5e329243"
import script from "./validation-errors.vue?vue&type=script&lang=js"
export * from "./validation-errors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../Shield.UI.ProductManagementSystemWebsite/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports